import React from "react";
import { Link } from "react-router-dom";

export default function Logo() {
    return (
        <div id="logo-div">
            <Link id="logo" to="/">Casual Fan</Link>
        </div>
    )
};